import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserService } from 'app/core/user/user.service';
import { UserRole } from 'app/core/user/user.types';

export const RoleGuard: CanActivateFn = (route) => {
  const userService = inject(UserService);
  const router = inject(Router);

  const allowedRoles: UserRole[] = route.data?.['roles'] ?? [];
  const currentUser = userService.currentUser();

  if (currentUser && allowedRoles.includes(currentUser.role)) {
    return true;
  }

  return router.parseUrl('/home');
};
